/**
 * ColorGridAnswer.js
 * Interactive answer grid where players tap to select colors.
 */

export default function ColorGridAnswer({ answers, handleBoxClick, handleSubmit }) {
    return (
        <div className="flex flex-col items-center justify-center">
            <div className="grid grid-cols-6 gap-2 sm:gap-3 justify-center mt-6">
                {answers.map((color, i) => (
                    <div
                        key={i}
                        onClick={() => handleBoxClick(i)}
                        className={`w-10 h-10 sm:w-14 sm:h-14 border border-zinc-700 rounded-md cursor-pointer transition-all duration-200 ${
                            color ? `bg-${color.toLowerCase()}` : "bg-zinc-800 hover:bg-zinc-700"
                        }`}
                    ></div>
                ))}
            </div>

            <button
                onClick={handleSubmit}
                className="mt-8 px-8 py-2 border border-white rounded-lg text-white hover:bg-white hover:text-black transition-all duration-300"
            >
                Submit
            </button>
        </div>
    );
}